"use client";;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:ENCON_SENTRY_KEY":true});}catch(e){}}();
import Button from "@/components/Button";
import type { Tag } from "@/payload-types";
import { useTranslations } from "next-intl";
import type React from "react";
import "./index.scss";
import {
  type FilterOption,
  useArchiveFilterParams,
} from "./useArchiveFilterParams";

export type { FilterOption };

export type FilterCategory = {
  title: string;
  options: FilterOption[];
};

export type Props = {
  onFilterChange?: (
    filters: Record<string, string[]>,
    searchQuery?: string,
    options?: { skipScroll?: boolean },
  ) => void;
  onIndustriesChange?: (industries: string[]) => void;
  className?: string;
  solutionTags: Tag[];
  industryTags: Tag[];
  frameworkTags: Tag[];
};

export const ArchiveFilter: React.FC<Props> = ({
  onFilterChange,
  onIndustriesChange,
  className,
  solutionTags,
  industryTags,
  frameworkTags,
}) => {
  const t = useTranslations("Archive");
  const tSearch = useTranslations("Header");
  const {
    filters,
    search,
    handleCheckboxChange,
    handleSearchChange,
    clearFilters,
  } = useArchiveFilterParams({
    solutionTags,
    industryTags,
    frameworkTags,
    onFilterChange,
    onIndustriesChange,
  });

  return (
    <div className={`archive-filter ${className || ""}`}>
      <div className="archive-filter__header">
        <div className="archive-filter__search">
          <input
            name="search"
            className="header-search__input"
            placeholder={tSearch("search.placeholder")}
            type="search"
            value={search}
            onChange={(e) => handleSearchChange(e.target.value)}
          />
        </div>
        {/** biome-ignore lint/a11y/useButtonType: <explanation> */}
        <Button
          variant="secondary"
          link="#"
          onClick={clearFilters}
          className="archive-filter__clear"
        >
          {t("clearFilters")}
        </Button>
      </div>

      <div className="archive-filter__columns">
        <div className="archive-filter__column">
          <h4 className="archive-filter__column-title archive-filter__column-title--solutions">
            {t("solutions")}
          </h4>
          <div className="archive-filter__options">
            {filters.solutions.map((option) => (
              <label key={option.id} className="archive-filter__option">
                <input
                  type="checkbox"
                  checked={option.checked}
                  onChange={() => handleCheckboxChange("solutions", option.id)}
                />
                <span className="archive-filter__checkbox"></span>
                {option.label}
              </label>
            ))}
          </div>
        </div>

        <div className="archive-filter__column">
          <h4 className="archive-filter__column-title archive-filter__column-title--industries">
            {t("industries")}
          </h4>
          <div className="archive-filter__options">
            {filters.industries.map((option) => (
              <label key={option.id} className="archive-filter__option">
                <input
                  type="checkbox"
                  checked={option.checked}
                  onChange={() => handleCheckboxChange("industries", option.id)}
                />
                <span className="archive-filter__checkbox"></span>
                {option.label}
              </label>
            ))}
          </div>
        </div>

        <div className="archive-filter__column">
          <h4 className="archive-filter__column-title archive-filter__column-title--framework">
            {t("profitableSustainabilityFramework")}
          </h4>
          <div className="archive-filter__options">
            {filters.framework.map((option) => (
              <label key={option.id} className="archive-filter__option">
                <input
                  type="checkbox"
                  checked={option.checked}
                  onChange={() => handleCheckboxChange("framework", option.id)}
                />
                <span className="archive-filter__checkbox"></span>
                {option.label}
              </label>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
